import { render } from "./MenuDrawer.vue?vue&type=template&id=324d588f"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"

import "./MenuDrawer.vue?vue&type=style&index=0&id=324d588f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__